import { useEffect } from 'react';
import { RouteProps, useLocation, useNavigate } from 'react-router-dom';
import { useGetUserInfoQuery } from '../../../services/api';

export default function PrivateRoute({ children, ...rest }: RouteProps) {
  const { data: user, error, isLoading } = useGetUserInfoQuery();
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (isLoading)
      return;

    const maybe = error as { status?: string | number }
    if (maybe?.status && ['FETCH_ERROR', 401].includes(maybe.status)) {
      navigate(`/login?redirectUrl=${encodeURIComponent(
        location.pathname + '?' + location.search.replace('?', '')
      )}`)
    }
  }, [error, isLoading, location.pathname, location.search, navigate])

  const renderChildren = !!user?.guid;

  if (isLoading || !user) {
    return null;
  }

  if (renderChildren) {
    return <>{children}</>
  }

  return null;
}
